var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pt-4 mb-n7"
  }, [_c('h4', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerCreateOrUpdateLandingpageSettigns.landingpageColorsTitle")) + " ")])]), _c('v-card', {
    staticClass: "my-2",
    attrs: {
      "flat": "",
      "max-width": "700"
    }
  }, [_c('v-card-text', [_c('v-color-picker', {
    attrs: {
      "dot-size": "25",
      "hide-mode-switch": "",
      "hide-sliders": "",
      "mode": "hexa",
      "show-swatches": "",
      "swatches-max-height": "100",
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.settings.color,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "color", $$v);
      },
      expression: "settings.color"
    }
  })], 1), _c('v-card-title', {
    staticClass: "title pt-4 mb-n7"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerCreateOrUpdateLandingpageSettigns.landingpageTextsTitle")))])]), _c('v-card-text', {
    staticClass: "mt-8"
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.cardTitle'),
      "hint": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.cardContentHint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.settings.cardTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "cardTitle", $$v);
      },
      expression: "settings.cardTitle"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.cardSubtitle'),
      "hint": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.cardContentHint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.settings.cardSubtitle,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "cardSubtitle", $$v);
      },
      expression: "settings.cardSubtitle"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.cardText'),
      "hint": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.cardTextHint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.settings.cardText,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "cardText", $$v);
      },
      expression: "settings.cardText"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.formTitle'),
      "hint": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.formTitleHint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.settings.formTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "formTitle", $$v);
      },
      expression: "settings.formTitle"
    }
  })], 1), _c('v-card-title', {
    staticClass: "title pt-4 mb-n7"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerCreateOrUpdateLandingpageSettigns.landingpageImagesTitle")))])]), _c('v-card-text', {
    staticClass: "mt-8"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.logo'),
      "hint": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.logoHint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.settings.logoUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "logoUrl", $$v);
      },
      expression: "settings.logoUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [!_vm.disabled ? _c('public-image-upload-dialog', {
    attrs: {
      "prefix": "logo",
      "folder": _vm.folderName
    },
    on: {
      "onUpload": _vm.handleLogo
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.headerImage'),
      "hint": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.headerImageHint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.settings.headerImageUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "headerImageUrl", $$v);
      },
      expression: "settings.headerImageUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [!_vm.disabled ? _c('public-image-upload-dialog', {
    attrs: {
      "prefix": "header",
      "folder": _vm.folderName
    },
    on: {
      "onUpload": _vm.handleHeader
    }
  }) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.favicon'),
      "hint": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.faviconHint'),
      "disabled": _vm.disabled,
      "outlined": "",
      "required": ""
    },
    model: {
      value: _vm.settings.favIconUrl,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "favIconUrl", $$v);
      },
      expression: "settings.favIconUrl"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [!_vm.disabled ? _c('public-image-upload-dialog', {
    attrs: {
      "prefix": "favicon",
      "folder": _vm.folderName
    },
    on: {
      "onUpload": _vm.handleFavIcon
    }
  }) : _vm._e()], 1), _c('PartnerDetailImage', {
    attrs: {
      "favIconUrl": _vm.settings.favIconUrl,
      "headerImageUrl": _vm.settings.headerImageUrl,
      "logoUrl": _vm.settings.logoUrl
    }
  })], 1)], 1), _c('v-card-title', {
    staticClass: "title pt-4 mb-n7"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t("components.partner.PartnerCreateOrUpdateLandingpageSettigns.displayMap")))])]), _c('v-card-text', {
    staticClass: "mt-8"
  }, [_c('v-checkbox', {
    attrs: {
      "label": _vm.$t('components.partner.PartnerCreateOrUpdateLandingpageSettigns.displayMap'),
      "disabled": _vm.disabled
    },
    model: {
      value: _vm.settings.displayMap,
      callback: function callback($$v) {
        _vm.$set(_vm.settings, "displayMap", $$v);
      },
      expression: "settings.displayMap"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }